// categoryColors.js — FUENTE UNICA del color por categoria del catalogo.
//
// Son los mismos hex que ya existian en src/scss/_color.scss ($categoria-*),
// los que pinta el punto de la card de escena (catalogo Salas) y los tiles de
// categoria. Todo el front (Salas, Itinerarios/SceneCard, etc.) debe usar este
// modulo para que los colores COINCIDAN en todas las pantallas. No inventar ni
// duplicar mapas por componente.

const DEFAULT_COLOR = "#8c9aa5";

// Normaliza el nombre (mayusculas, sin tildes) para clave estable.
export function normalizeCategoryKey(name) {
  return String(name || "")
    .trim()
    .toUpperCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "");
}

// Colores canonicos (src/scss/_color.scss). Clave = nombre normalizado.
export const CATEGORY_COLORS = {
  "CIENCIAS HUMANAS": "#f39c12",
  "CIENCIAS NATURALES": "#28a745",
  HISTORIA: "#795548",
  MATEMATICAS: "#007bff",
  ARTE: "#e83e8c",
  "VIDA SALUDABLE": "#17a2b8",
  OTROS: "#b8b8b8",
};

// Color de una categoria por su nombre. `fallback` para nombres no mapeados
// (p.ej. subcategorias con su propia paleta); por defecto gris neutro.
export function getCategoryColor(name, fallback = DEFAULT_COLOR) {
  return CATEGORY_COLORS[normalizeCategoryKey(name)] || fallback;
}

export { DEFAULT_COLOR };
